import type { Track } from "@similarweb/tracking-provider";

import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

export const createManageIntegrationTrackingService = (track: Track) => {
    const trackToggle = (isEnabled: boolean, crm: Integration, actionName: string, eventName: string) => {
        const action = isEnabled ? "enable" : "disable";
        const subSubName = isEnabled ? "on" : "off";

        track(`${crm} integration`, `${action} ${actionName}`, `${eventName}/${subSubName}`);
    };

    return {
        trackSalesforceActivityToggle(isEnabled: boolean) {
            trackToggle(isEnabled, "salesforce", "show salesforce activity", `show salesforce activity/extension`);
        },
        trackAccountStatusToggle(isEnabled: boolean, crm: Integration) {
            trackToggle(isEnabled, crm, "show status", `show status/${crm} accounts`);
        },
        trackAccountSelectStatusField(crm: Integration) {
            track(`${crm} integration`, "pick status field", "show status");
        },
    };
};
